import React, { useState, useEffect, useContext } from 'react';
import NewInterviewPrimary from './NewInterviewPrimary';
import { CHAT_TAB_VIEWS, PAGE_VIEW, ClassNameEvent, UpdatingChatHistoryState, SourceType } from '../types';

import NewInterviewSecondary from './NewInterviewSecondary';
import BulkUpload from './BulkUpload';
import CreateProjectModal from './CreateProjectModal';
import { APIContext } from '../contexts/APIContext';
import { trackUserClicks, getValidToken } from '../utils';
import { SessionContext } from '../contexts/SessionContext';

const UploadTranscript = () => {
  const [researchType, setResearchType] = useState<'Primary' | 'Secondary'>('Primary');
  const [uploadTab, setUploadTab] = useState<'NewInterview' | 'BulkUpload'>('NewInterview');
  const [showCreate, setShowCreate] = useState(false);
  const {
    websocketConnected,
    accounts,
    userDetails,
    chatSessionId,
    websocketConnectionRef: { current: websocket },
    AppName,
    WBUId,
  } = useContext(APIContext);
  const { pageView, setPageView, setOpenAI, setGenAI, isPromptGenerating, setIsUpdatingChatHistory } =
    useContext(SessionContext);

  useEffect(() => {
    setTimeout(() => {
      (async () => {
        const token = await getValidToken();
        trackUserClicks(websocket, 'NewInterview', userDetails, chatSessionId, WBUId, AppName, accounts, token);
      })();
    }, 500);
  }, []);

  useEffect(() => {
    if (showCreate) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [showCreate]);

  const handleModalClick = async () => {
    const token = await getValidToken();
    trackUserClicks(websocket, 'CreateProject', userDetails, chatSessionId, WBUId, AppName, accounts, token);
    setShowCreate(true);
  };

  const handleNavbarClick = async (view: PAGE_VIEW) => {
    const token = await getValidToken();
    trackUserClicks(websocket, 'GMA Landing Page', userDetails, chatSessionId, WBUId, AppName, accounts, token);
    if (view === pageView) {
      setPageView(PAGE_VIEW.LANDING);
    } else {
      setPageView(view);
    }
  };
  return (
    <>
      <div className="c-chat-header">
        <div className="c-chat-header__wrapper">
          <div className="c-chat-header__right" onClick={() => handleNavbarClick(PAGE_VIEW.LANDING)}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className=" !block c-chat-header__home-icon width="
              width="16"
              height="17"
              viewBox="0 0 16 17"
              fill="none"
            >
              <path
                d="M9.51172 16.4717V11.8447H6.31201V16.4717H0.755859V7.24609L7.94287 2.29883L15.127 7.24609V16.4717H9.51172ZM10.2119 11.2041V15.8037H14.4609V7.62695L7.94287 3.11816L1.42188 7.59668V15.8027H5.6709V11.2031L10.2119 11.2041ZM7.94287 0.81543L0.375 6.02539L0 5.5L7.94287 0L15.8857 5.5L15.5049 6.02539L7.94287 0.81543Z"
                fill="black"
              ></path>
            </svg>
            <div className="c-chat-header__title">GMA</div>
          </div>
        </div>
      </div>
      <div className="c-upload-transcript">
        <div className="c-upload-transcript__wrapper">
          <span className="c-upload-transcript__title">Upload Transcript</span>
          <div className="c-modals__container">
            <button
              type="button"
              className="o-primary-button "
              data-modalid="projectModal"
              aria-label="Sample Modal"
              onClick={handleModalClick}
            >
              Create a New Project
            </button>{' '}
          </div>
        </div>
        <div role="tablist" aria-label="Tabs Label" className="c-tabs__wrap">
          <button
            type="button"
            className="c-tabs__btn"
            role="tab"
            aria-controls="t1"
            aria-selected={uploadTab === 'NewInterview'}
            tabIndex={uploadTab === 'NewInterview' ? 0 : -1}
            onClick={() => {
              setUploadTab('NewInterview');
              (async () => {
                const token = await getValidToken();
                trackUserClicks(websocket, 'NewInterview', userDetails, chatSessionId, WBUId, AppName, accounts, token);
              })();
            }}
          >
            New Interview
          </button>
          <button
            type="button"
            className="c-tabs__btn"
            role="tab"
            aria-controls="t2"
            aria-selected={uploadTab === 'BulkUpload'}
            tabIndex={uploadTab === 'BulkUpload' ? 0 : -1}
            onClick={() => {
              setUploadTab('BulkUpload');
              (async () => {
                const token = await getValidToken();
                trackUserClicks(websocket, 'BulkUpload', userDetails, chatSessionId, WBUId, AppName, accounts, token);
              })();
            }}
          >
            Bulk Upload
          </button>
        </div>
        <div
          role="tabpanel"
          id="t1"
          className={`${uploadTab === 'NewInterview' ? '-show' : ''}`}
          style={{ paddingBottom: '75px' }}
        >
          {researchType === 'Primary' ? (
            <NewInterviewPrimary researchType={researchType} setResearchType={setResearchType} />
          ) : (
            <NewInterviewSecondary researchType={researchType} setResearchType={setResearchType} />
          )}
        </div>
        <div role="tabpanel" id="t2" className={`${uploadTab === 'BulkUpload' ? '-show' : ''}`}>
          <BulkUpload />
        </div>
      </div>
      {showCreate && <CreateProjectModal setShowCreate={setShowCreate} showCreate={showCreate} />}
    </>
  );
};

export default UploadTranscript;
